<template>
  <el-autocomplete
    class="inline-input"
    v-model="subString"
    :maxlength="64"
    :fetch-suggestions="querySearch"
    :placeholder="_placeholder"
    :tips="$t('v_email_64')"
    :disabled="disabled"
    data-input-type="nospace"
    v-input-limit
    :trigger-on-focus="false"
    @input="handleInput"
    :debounce="0"
    :width="width"
  ></el-autocomplete>
</template>

<script>
export default {
  name: 'EmailInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      subString: ''
    };
  },
  computed: {
    _placeholder() {
      return this.placeholder ?? this.$t('e-mail');
    }
  },
  watch: {
    value: {
      handler(newV) {
        this.subString = newV;
      },
      immediate: true
    }
  },
  methods: {
    querySearch(queryString, cb) {
      if (queryString.length > 52) {
        cb([]);
        return;
      }
      let subString = '';
      if (queryString.split('@').length > 1) {
        subString = queryString.split('@')[0];
      } else {
        subString = queryString;
      }
      let showList = [
        `${subString }@gmail.com`,
        `${subString }@outlook.com`,
        `${subString }@hotmail.com`,
        `${subString }@icloud.com`,
        `${subString }@yahoo.com`
      ];
      let results = showList.filter((res) => res.indexOf(queryString) > -1);
      cb(results);
    },
    handleInput(val) {
      this.subString = val;
      this.$emit('input', val);
    }
  }
};
</script>

<style scoped></style>
